import axios from 'axios'
import queryString from 'query-string'

import { ERROR_MESSAGE_DELETING_FILE, ERROR_MESSAGE_DOWNLOADING_FILE } from '../constants'
import { reportFileUploadError } from '../helpers/sentry'
import { formatFileUploadErrorMessage, formatFileUploadSuccessMessage, truncateTextMiddle } from '../helpers/strings'
import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const DELETE_USER_FILE = 'DELETE_USER_FILE'
export const DOWNLOAD_USER_FILE = 'DOWNLOAD_USER_FILE'
export const DOWNLOAD_USER_FILE_CONTENT = 'DOWNLOAD_USER_FILE_CONTENT'
export const RECEIVE_USER_FILES = 'RECEIVE_USER_FILES'
export const REMOVE_AND_DELETE_USER_FILE = 'REMOVE_AND_DELETE_USER_FILE'
export const REMOVE_USER_FILE = 'REMOVE_USER_FILE'
export const REQUEST_USER_FILES = 'REQUEST_USER_FILES'
export const UPLOAD_USER_FILE = 'UPLOAD_USER_FILE'
export const REQUEST_USER_FILE_DOWNLOAD_LINK = 'REQUEST_USER_FILE_DOWNLOAD_LINK'

export const requestUserFiles = () => (dispatch) => {
    dispatch({ type: REQUEST_USER_FILES })

    return axios
        .get('/userfiles')
        .then((response) => {
            const data = response?.data || {}
            dispatch(receiveUserFiles({ items: data, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveUserFiles({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveUserFiles({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveUserFiles = (data) => (dispatch) => {
    dispatch({ type: RECEIVE_USER_FILES, data })
}

export const uploadUserFile = (data) => (dispatch) => {
    dispatch({ type: UPLOAD_USER_FILE, data })

    const { fileType, identityVerificationId, file } = data

    const params = queryString.stringify({
        fileType,
        ...(identityVerificationId ? { identityVerificationId } : {}),
    })

    const url = `/userfiles?${params}`

    const formData = new FormData()
    formData.append('file', file)

    return axios
        .post(url, formData)
        .then(() => {
            dispatch(receiveSuccessAlert(formatFileUploadSuccessMessage(file?.name)))
            dispatch(requestUserFiles())
        })
        .catch((error) => {
            reportFileUploadError(error, file)
            dispatch(handleRequestError(error, { customMessage: formatFileUploadErrorMessage(file?.name) }))
            return Promise.reject(error)
        })
}

export const removeAndDeleteUserFile =
    (data, options = {}) =>
    (dispatch) => {
        dispatch({ type: REMOVE_AND_DELETE_USER_FILE, data })

        dispatch(removeUserFile(data))
        return dispatch(deleteUserFile(data, options))
    }

export const removeUserFile =
    ({ id }) =>
    (dispatch, getState) => {
        dispatch({ type: REMOVE_USER_FILE, data: { id } })

        const { userFiles } = getState()

        const newData = userFiles.items.filter((e) => e.id !== id)

        dispatch(receiveUserFiles({ items: newData }))
    }

export const deleteUserFile =
    (data, { hideAlert = false } = {}) =>
    (dispatch) => {
        dispatch({ type: DELETE_USER_FILE, data })

        const { id, fileName } = data

        return axios
            .delete(`/userfiles/${id}`)
            .then(() => {
                dispatch(removeUserFile({ id }))

                if (!hideAlert) {
                    dispatch(
                        receiveSuccessAlert(`Archivo ${fileName ? `"${truncateTextMiddle(fileName)}"` : ''} eliminado`)
                    )
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING_FILE }))
            })
    }

export const downloadUserFile = (data) => (dispatch) => {
    dispatch({ type: DOWNLOAD_USER_FILE, data })

    dispatch(requestUserFileDownloadLink(data)).then((userFile) => {
        if (userFile) {
            window.location.assign(userFile)
        }
    })
}

export const requestUserFileDownloadLink = (data) => (dispatch) => {
    dispatch({ type: REQUEST_USER_FILE_DOWNLOAD_LINK, data })

    const { id } = data

    return axios
        .get(`/userfiles/${id}/downloadlink`)
        .then((response) => response.data)
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DOWNLOADING_FILE }))
        })
}

export const requestUserLogo = (data) => (dispatch) => {
    dispatch({ type: REQUEST_USER_FILE_DOWNLOAD_LINK, data })

    const { id } = data

    return axios
        .get(`/userfiles/${id}/logo`)
        .then((response) => response.data)
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DOWNLOADING_FILE }))
        })
}

export const downloadUserFileContent = (data) => (dispatch) => {
    dispatch({ type: DOWNLOAD_USER_FILE_CONTENT, data })

    const { id } = data

    return axios
        .get(`/userfiles/${id}/filecontent`, {
            responseType: 'blob',
        })
        .then((response) => response?.data)
        .catch((error) => {
            dispatch(handleRequestError(error))
            return Promise.reject(error)
        })
}
